type Props = {
  title: React.ReactNode;
  controls?: React.ReactNode;
};

export const PageHeader = ({ title, controls }: Props) => (
  <div className="border-gxe-border flex items-end justify-between border-b bg-white px-8 pt-32 pb-9 max-lg:flex-col max-lg:items-start max-lg:gap-4">
    <h1 className="w-full text-6xl font-bold max-lg:truncate">{title}</h1>
    {controls}
  </div>
);
